
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section id="contact" className="py-32 bg-gradient-to-br from-[#0F2744] via-[#1A2F4A] to-[#0A1628] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-64 h-64 bg-[#D4AF37] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#D4AF37] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-5xl md:text-6xl font-serif font-bold text-white mb-8 whitespace-nowrap">
          <span className="font-sans text-[#D4AF37] font-light text-6xl md:text-7xl">"</span>당신의 이야기를 세상에 전하세요<span className="font-sans text-[#D4AF37] font-light text-6xl md:text-7xl">"</span>
        </h2>
        
        <p className="text-xl text-gray-300 mb-12 leading-relaxed max-w-2xl mx-auto">
          크레딧은 당신의 가치를 믿습니다.<br />
          함께 의미 있는 책을 만들어가겠습니다.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mb-16">
          <a
            href="https://"
            className="inline-flex items-center gap-3 bg-[#D4AF37] text-[#0A1628] px-10 py-5 rounded-full text-lg font-bold hover:bg-[#F4D03F] transition-all hover:gap-4 cursor-pointer whitespace-nowrap shadow-lg shadow-[#D4AF37]/20"
          >
            원고 투고하기
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>

        <div className="inline-flex items-center gap-3 bg-[#D4AF37]/10 px-8 py-4 rounded-full border border-[#D4AF37]/30">
          <i className="ri-heart-line text-2xl text-[#D4AF37]"></i>
          <p className="text-gray-200 font-medium text-lg">
            Cr.edit — 우리는 당신의 가치를 믿습니다.
          </p>
        </div>
      </div>
    </section>
  );
}
